// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world

import wixLocation from 'wix-location';
$w.onReady(function () {
	console.log(wixLocation.path);
	if(wixLocation.path.length < 3){
		wixLocation.to('/clinic/'+wixLocation.path[1])
	}
	
	// Write your JavaScript here

	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});
